export default __webpack_public_path__ + "static/media/black_gear.485ec87f.svg";